import { observer } from 'mobx-react';
import { useStore } from '../../../../../store/store';
import { ICON_BUTTON_ICONS } from '../../../../../components/buttons/IconButton';

/**
 * ProfilerDemoMessage - Shared demo limit message for profiler searches
 *
 * Displays the remaining demo searches count or exceeded limit message.
 * Used across Corporates and Individuals tabs.
 */
const ProfilerDemoMessage = observer(() => {
  const { profilerAccessStore } = useStore();

  if (!profilerAccessStore.isProfilerDemo) {
    return null;
  }

  return (
    <div
      className={`profiler-demo-info-message${
        profilerAccessStore.demoSearchExceededLimit ? ' exceeded' : ''
      }`}
    >
      <div className="img-wrap">
        <img src={ICON_BUTTON_ICONS.EXCLAMATAION_CIRCLE} alt="" />
      </div>
      <div className="text">
        {profilerAccessStore.demoSearchExceededLimit ? (
          <>
            You&apos;ve used all {profilerAccessStore.demoSearchMaxCount} demo searches - upgrade to
            full access to continue exploring.
          </>
        ) : (
          <>
            You have {profilerAccessStore.demoSearchRemainingCount} out of{' '}
            {profilerAccessStore.demoSearchMaxCount} demo searches remaining - upgrade to full
            access to unlock unlimited searches.
          </>
        )}
      </div>
    </div>
  );
});

export default ProfilerDemoMessage;
